import { z } from 'zod';
import { guardExhaustive } from 'libs/end-to-end/src/generic';
import { DatabaseScheduleRetryableEnableFor } from 'libs/end-to-end/src/types/databases/scheduling/database-schedule-retryable-enable-for';

export const DatabaseScheduleRunStage = z.enum([
  'setup',
  'dataset-pull',
  'ai-interviewer-write-back',
  'prepare-transform',
  'transform',
  'prepare-revision',
  'publish-revision',
  'validate-revision',
  'top-level-analysis',
  'recover-from-top-level-analysis',
  'candidate-revision-index-builder',
  'hiring-copilot-execution-workflow',
  'hiring-score-write-back',
  'hiring-explanation-write-back',
  'hiring-notification-sender',
  'promotion-copilot-execution-workflow',
  'promotion-score-write-back',
  'promotion-explanation-write-back',
  'candidate-resume-score-write-back',
  'bad-language-detector-write-back',
  'done',
]);

export type DatabaseScheduleRunStage = z.infer<typeof DatabaseScheduleRunStage>;

export const DatabaseScheduleRunStageInformation = z.object({
  stage: DatabaseScheduleRunStage,
  startedAtEpoch: z.number(),
  endedAtEpoch: z.number().nullable(),
  isCurrent: z.boolean(),
});

export type DatabaseScheduleRunStageInformation = z.infer<
  typeof DatabaseScheduleRunStageInformation
>;

export const databaseScheduleRunStageToDatabaseScheduleRetryableEnableFor = (
  stage: DatabaseScheduleRunStage,
): DatabaseScheduleRetryableEnableFor | null => {
  console.log('stage', stage);
  switch (stage) {
    case 'transform':
      return 'transforms';
    case 'dataset-pull':
    case 'prepare-transform':
      return 'datasets';
    case 'candidate-revision-index-builder':
    case 'hiring-copilot-execution-workflow':
    case 'hiring-score-write-back':
    case 'promotion-score-write-back':
    case 'candidate-resume-score-write-back':
    case 'bad-language-detector-write-back':
    case 'hiring-explanation-write-back':
    case 'promotion-explanation-write-back':
    case 'hiring-notification-sender':
    case 'promotion-copilot-execution-workflow':
      return 'post-tlp-flows';
    case 'setup':
    case 'ai-interviewer-write-back':
    case 'prepare-revision':
    case 'publish-revision':
    case 'validate-revision':
    case 'top-level-analysis':
    case 'recover-from-top-level-analysis':
    case 'done':
      return null;
    default:
      throw guardExhaustive(stage);
  }
};
